import { getReadableTextColor } from '@/lib/accessibility';

export function PaletteStrip({
  colors,
  onSelect,
  label = 'Palette colors',
  compact = false,
}: {
  colors: string[];
  onSelect?: (color: string, index: number) => void;
  label?: string;
  compact?: boolean;
}) {
  return (
    <div className={`palette-strip${compact ? ' palette-strip-compact' : ''}`} aria-label={label}>
      {colors.map((color, index) =>
        onSelect ? (
          <button
            key={index}
            type="button"
            style={{ backgroundColor: color, color: getReadableTextColor(color) }}
            onClick={() => onSelect(color, index)}
            aria-label={`${label}: ${color}, color ${index + 1}`}
            title={color}
          >
            {!compact && <code>{color}</code>}
          </button>
        ) : (
          <span key={index} style={{ backgroundColor: color }} title={color} />
        ),
      )}
    </div>
  );
}
